export default __webpack_public_path__ + "static/rocketship-logo-circle-e4c9f499609ce2d35dfeec130b99ebdf.svg";